import type { ReactNode } from 'react';

export interface KpiCardSkeletonProps {
  readonly 'aria-label'?: string;
  readonly className?: string;
}

/**
 * Spec-shaped KPI loading chrome (Icon well → Title bar → Value bar).
 * Use inside KpiGrid with matching --N; set aria-busy on the hub kpi slot when shown.
 */
export function KpiCardSkeleton({
  'aria-label': ariaLabel = 'Loading metric',
  className,
}: KpiCardSkeletonProps): ReactNode {
  return (
    <div
      className={[
        'flex h-full w-full min-w-0 flex-col items-center rounded-xl border border-[var(--color-rail-card-border)] bg-[var(--color-an-surface)] p-4 text-center shadow-sm',
        className ?? '',
      ]
        .join(' ')
        .trim()}
      data-testid="kpi-card-skeleton"
      aria-busy="true"
      aria-label={ariaLabel}
    >
      <div className="h-8 w-8 shrink-0 animate-pulse rounded-lg bg-[var(--color-an-bg-elevated)]" />
      <div className="mt-2 h-3 w-3/4 max-w-[9rem] animate-pulse rounded bg-[var(--color-an-bg-elevated)]" />
      <div className="mt-3 h-7 w-1/2 max-w-[6rem] animate-pulse rounded bg-[var(--color-an-bg-elevated)]" />
    </div>
  );
}
